const MARKUP_SUMMARY = {
  salesAmount: {
    label: 'Preço de Venda no Zé',
    tooltipText:
      'Valores dos produtos pagos pelos clientes, sem considerar taxas, comissões ou entregas.',
  },
  sellerMarkupRate: {
    label: 'Markup',
    tooltipText:
      'Porcentagem negociada para calcular a restituição/correção dos valores de venda dos produtos Ambev.',
  },
  purchaseAmount: {
    label: 'Preço de Compra Ambev',
    tooltipText:
      'Valor pago por você na compra via plataforma da BEES ou o valor da tabela padrão, definido pelo Zé.',
  },
  expectedPurchaseAmount: {
    label: 'Referência Markup',
    tooltipText: 'Valor ideial que deveria ter sido pago nos produtos ',
  },
  downloadButtonTextSuffix: 'markup por pedido',
  onePlusMarkup: '(1 + Markup)',
  onePlus: '1 + ',
  equals: '=',
  errorMessage:
    'Houve um erro ao carregar o resumo de markup. Tente novamente mais tarde.',
  errorMessageMarkupTotalMismatch: 'Restitution details markup total mismatch',
}

export default MARKUP_SUMMARY
